<div class="tracking-container">
  <!-- Full-page loading overlay - stays until vehicles + markers are fully loaded -->
  @if (isLoading) {
  <div class="full-page-loader">
    <div class="loader-spinner"></div>
    <span class="loader-text">Loading vehicles...</span>
  </div>
  }

  <!-- Fixed Map Background -->
  <div class="map-background">
    <div id="tracking-map"></div>
    <!-- Playback preparation loader overlay -->
    @if (playbackLoading) {
    <div class="map-loader-overlay">
      <div class="loader-spinner"></div>
      <span class="loader-text">Preparing playback...</span>
    </div>
    }
  </div>

  <!-- Left Sidebar - Vehicle List (Overlay - shown in both modes) -->
  <aside
    class="vehicle-sidebar"
    [class.collapsed]="!leftDrawerOpen"
    [class.playback-mode]="activeHeaderTab === 'playback'"
  >
    <div class="sidebar-header">
      <div class="header-left">
        @if (fromUrbanDashboard) {
        <button
          (click)="goBackToDashboard()"
          class="flex items-center gap-1 px-3 py-1.5 bg-gradient-to-r from-slate-600 to-slate-700 hover:from-slate-700 hover:to-slate-800 text-white rounded-lg transition-all duration-200 shadow-sm text-xs font-medium cursor-pointer border-0 mb-1"
        >
          <svg
            class="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 17l-5-5m0 0l5-5m-5 5h12"
            ></path>
          </svg>
          Go Back
        </button>
        }
        <div class="mode-toggle-container">
          <button
            type="button"
            class="mode-toggle-btn"
            [class.active]="activeHeaderTab === 'livetrack'"
            (click)="activateHeaderTab('livetrack')"
          >
            <span class="mode-icon">📡</span>
            <span class="mode-label">Live Track</span>
          </button>
          <button
            type="button"
            class="mode-toggle-btn"
            [class.active]="activeHeaderTab === 'playback'"
            (click)="activateHeaderTab('playback')"
          >
            <span class="mode-icon">⏱️</span>
            <span class="mode-label">Playback</span>
          </button>
        </div>
      </div>
      <div class="header-icons">
        <!-- <button type="button" class="icon-btn" title="Person">
        <span>👤</span>
      </button>
      <button type="button" class="icon-btn" title="Car">
        <span>🚗</span>
      </button> -->
        <button
          type="button"
          class="icon-btn"
          title="Grid"
          (click)="toggleFiltersPanel()"
          [class.active]="showFiltersPanel"
        >
          <span>⊞</span>
        </button>
        <button
          type="button"
          class="icon-btn close-btn"
          title="Close"
          (click)="toggleLeftDrawer()"
        >
          <span>×</span>
        </button>
      </div>
    </div>
    @if (activeHeaderTab === 'livetrack') {
    <div>
      <!-- Status Summary (matching live-tracking component) - 4 cards per row -->
      <div class="status-summary">
        <!-- First Row: ALL, Online, Offline, Repair -->
        <div class="status-row">
          <div
            class="status-box total"
            (click)="applySummaryFilter('total')"
            [class.active]="activeSummaryKey === 'total'"
            [style.background]="
              activeSummaryKey === 'total' ? '#b36005' : '#e8a04a'
            "
            [style.color]="activeSummaryKey === 'total' ? '#ffffff' : '#8b4e00'"
          >
            <span class="status-count">{{ getStatusCount("total") }}</span>
            <span class="status-label">{{
              summaryCards[0]?.label || "ALL"
            }}</span>
          </div>
          <div
            class="status-box online"
            (click)="applySummaryFilter('online')"
            [class.active]="activeSummaryKey === 'online'"
            [style.background]="
              activeSummaryKey === 'online' ? '#4caf50' : '#81c784'
            "
            [style.color]="
              activeSummaryKey === 'online' ? '#ffffff' : '#2e7d32'
            "
          >
            <span class="status-count">{{ getStatusCount("online") }}</span>
            <span class="status-label">{{
              summaryCards[1]?.label || "Online"
            }}</span>
          </div>
          <div
            class="status-box offline"
            (click)="applySummaryFilter('offline')"
            [class.active]="activeSummaryKey === 'offline'"
            [style.background]="
              activeSummaryKey === 'offline' ? '#ff7043' : '#ffab91'
            "
            [style.color]="
              activeSummaryKey === 'offline' ? '#ffffff' : '#d84315'
            "
          >
            <span class="status-count">{{ getStatusCount("offline") }}</span>
            <span class="status-label">{{
              summaryCards[2]?.label || "Offline"
            }}</span>
          </div>
          <div
            class="status-box repair"
            (click)="applySummaryFilter('repair')"
            [class.active]="activeSummaryKey === 'repair'"
            [style.background]="
              activeSummaryKey === 'repair' ? '#754fb8' : '#b39ddb'
            "
            [style.color]="
              activeSummaryKey === 'repair' ? '#ffffff' : '#4527a0'
            "
          >
            <span class="status-count">{{ getStatusCount("repair") }}</span>
            <span class="status-label">{{
              summaryCards[3]?.label || "Repair"
            }}</span>
          </div>
          <div
            class="status-box others"
            (click)="applySummaryFilter('others')"
            [class.active]="activeSummaryKey === 'others'"
            [style.background]="
              activeSummaryKey === 'others' ? '#354f5b' : '#90a4ae'
            "
            [style.color]="
              activeSummaryKey === 'others' ? '#ffffff' : '#263238'
            "
          >
            <span class="status-count">{{ getStatusCount("others") }}</span>
            <span class="status-label">{{
              summaryCards[4]?.label || "Others"
            }}</span>
          </div>
        </div>
        <!-- Second Row: Others, Running, Stationed <5min, Stationed 5-15min, Stationed >15min (5 cards) -->
        <div class="status-row">
          <div
            class="status-box running"
            (click)="applySummaryFilter('running')"
            [class.active]="activeSummaryKey === 'running'"
            [style.background]="
              activeSummaryKey === 'running' ? '#26a69a' : '#4db6ac'
            "
            [style.color]="
              activeSummaryKey === 'running' ? '#ffffff' : '#00695c'
            "
          >
            <span class="status-count">{{ getStatusCount("running") }}</span>
            <span class="status-label">{{
              summaryCards[5]?.label || "Running"
            }}</span>
          </div>
          <div
            class="status-box stationed-short"
            (click)="applySummaryFilter('stationedShort')"
            [class.active]="activeSummaryKey === 'stationedShort'"
            [style.background]="
              activeSummaryKey === 'stationedShort' ? '#6557f7' : '#7986cb'
            "
            [style.color]="
              activeSummaryKey === 'stationedShort' ? '#ffffff' : '#283593'
            "
          >
            <span class="status-count">{{
              getStatusCount("stationedShort")
            }}</span>
            <span class="status-label">{{
              summaryCards[6]?.label || "Stationed <5min"
            }}</span>
          </div>
          <div
            class="status-box stationed-medium"
            (click)="applySummaryFilter('stationedMedium')"
            [class.active]="activeSummaryKey === 'stationedMedium'"
            [style.background]="
              activeSummaryKey === 'stationedMedium' ? '#ffb74d' : '#ffcc80'
            "
            [style.color]="
              activeSummaryKey === 'stationedMedium' ? '#ffffff' : '#e65100'
            "
          >
            <span class="status-count">{{
              getStatusCount("stationedMedium")
            }}</span>
            <span class="status-label">{{
              summaryCards[7]?.label || "Stationed 5-15min"
            }}</span>
          </div>
          <div
            class="status-box stationed-long"
            (click)="applySummaryFilter('stationedLong')"
            [class.active]="activeSummaryKey === 'stationedLong'"
            [style.background]="
              activeSummaryKey === 'stationedLong' ? '#ef5350' : '#ef9a9a'
            "
            [style.color]="
              activeSummaryKey === 'stationedLong' ? '#ffffff' : '#b71c1c'
            "
          >
            <span class="status-count">{{
              getStatusCount("stationedLong")
            }}</span>
            <span class="status-label">{{
              summaryCards[8]?.label || "Stationed >15min"
            }}</span>
          </div>
        </div>
      </div>
      <!-- Loading handled by full-page-loader overlay -->
      <app-data-grid
        id="gridContainer"
        class="lvetracktable"
        [dataSource]="stslist"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="false"
        [columnChooser]="false"
        [allowExport]="false"
        [pageSize]="10"
        [allowedPageSizes]="[10]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
        (rowClick)="getEahVehicle($event)"
        [cellPrepared]="bound_onCellPrepared"
      >
        <!---->
        <app-grid-column
          dataField="sno"
          caption="Sno"
          width="40"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="asrt_nm"
          caption="Vehicle"
          alignment="center"
          width="80"
        ></app-grid-column>
        <app-grid-column
          dataField="asrt_sts_nm"
          dataType="string"
          caption="Status"
          cellTemplate="stsTemplate"
          alignment="center"
          width="100"
        ></app-grid-column>
        <app-grid-column
          dataField="asrt_ctgry_nm"
          caption="Category"
          width="90"
          alignment="left"
        ></app-grid-column>
        <app-grid-column
          dataField="tdy_dst"
          caption="Distance"
          alignment="center"
          width="80"
        ></app-grid-column>
        <ng-template appGridCell="stsTemplate" let-d="cell"
          ><div>
            <div
              [ngStyle]="{ color: d.row.data.clr_cd }"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 4px;
              "
            >
              <span
                ><img
                  src="assets/images/markers/mapIcons/m/sgnl_{{
                    d.row.data.sgnl_strngth_ct
                  }}.png"
                  alt=""
                  style="height: 15px; width: 15px"
                />
              </span>
              <span
                ><img
                  src="assets/images/markers/mapIcons/m/igntn_{{
                    d.row.data.igntn_in
                  }}.png"
                  alt=""
                  style="height: 15px; width: 15px"
                />
              </span>
              <span
                ><img
                  src="assets/images/markers/mapIcons/m/chrg_{{
                    d.row.data.chrg_in
                  }}.png"
                  alt=""
                  style="height: 15px; width: 15px"
                />
              </span>
              <span
                [ngClass]="
                  d.row.data.spd_ct > 0 && d.row.data.diffTimeInMin < 5
                    ? 'greenCls'
                    : d.row.data.spd_ct >= 0 && d.row.data.diffTimeInMin <= 5
                    ? 'blueCls'
                    : d.row.data.spd_ct >= 0 &&
                      d.row.data.diffTimeInMin >= 5 &&
                      d.row.data.diffTimeInMin < 15
                    ? 'yellowCls'
                    : 'redCls'
                "
              ></span>
            </div></div
        ></ng-template>
        <app-grid-column
          [showInColumnChooser]="false"
          caption="View"
          alignment="center"
          width="60"
          [allowSorting]="false"
          cellTemplate="playbackTemplate"
          [visible]="true"
        ></app-grid-column>
        <ng-template appGridCell="playbackTemplate" let-data="cell"
          ><div>
            <div
              class="tblEdtBtn"
              (click)="onPlaybackIconClick(data.data, $event)"
              title="Go to Playback"
            >
              <i
                nz-icon
                nzType="play-circle"
                nzTheme="outline"
                style="color: #667eea; cursor: pointer"
              ></i>
            </div></div
        ></ng-template>
      </app-data-grid>
    </div>
    }
    <!-- Playback Filters (shown when in playback mode) -->
    @if (activeHeaderTab === 'playback') {
    <div class="playback-filters-aside">
      <!-- Row 1: Vehicle filter (1 part) | Timeline/Trip toggle (2nd part) -->
      <div class="playback-row-1">
        <div class="playback-col-1">
          <label class="filter-label">Select Vehicle</label>
          <nz-select
            class="slctBx"
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Please select Vehicle"
            [(ngModel)]="playbackFilters.vehicleId"
            (ngModelChange)="onPlaybackVehicleChange()"
            style="width: 100%"
            nzSize="small"
          >
            @for (vehicle of filteredPlaybackVehicles; track vehicle) {
            <nz-option
              [nzLabel]="vehicle.id || vehicle.asrt_nm"
              [nzValue]="$safeNavigationMigration(vehicle.asrt_id?.toString())"
            ></nz-option>
            }
          </nz-select>
        </div>
        <div class="playback-col-2">
          <label class="filter-label">Mode</label>
          <div class="notch-tabs">
            <button
              type="button"
              [class.active]="playbackMode === 'range'"
              (click)="setPlaybackMode('range')"
            >
              Timeline
            </button>
            <button
              type="button"
              [class.active]="playbackMode === 'trip'"
              (click)="setPlaybackMode('trip')"
            >
              Trip
            </button>
          </div>
        </div>
      </div>
      <!-- Row 2: Timeline Fields — dd-mm-yyyy HH:mm:ss display with calendar icon -->
      @if (playbackMode === 'range') {
      <div class="playback-row-2">
        <div class="playback-col-timeline">
          <label class="filter-label">From</label>
          <div class="relative flex items-center">
            <input
              type="text"
              readonly
              class="w-full pl-2 pr-7 py-1.5 text-xs bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
              [value]="playbackFilters.fromDisplay || ''"
              placeholder="DD-MM-YYYY HH:mm:ss"
              (click)="fromDatePicker.showPicker()"
            />
            <svg
              class="absolute right-2 w-3.5 h-3.5 text-gray-400 pointer-events-none"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <input
              #fromDatePicker
              type="datetime-local"
              class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              [(ngModel)]="playbackFilters.from"
              [max]="todayDateTimeMax"
              (ngModelChange)="onFromPickerChange()"
            />
          </div>
        </div>
        <div class="playback-col-timeline">
          <label class="filter-label">To</label>
          <div class="relative flex items-center">
            <input
              type="text"
              readonly
              class="w-full pl-2 pr-7 py-1.5 text-xs bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
              [value]="playbackFilters.toDisplay || ''"
              placeholder="DD-MM-YYYY HH:mm:ss"
              (click)="toDatePicker.showPicker()"
            />
            <svg
              class="absolute right-2 w-3.5 h-3.5 text-gray-400 pointer-events-none"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <input
              #toDatePicker
              type="datetime-local"
              class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              [(ngModel)]="playbackFilters.to"
              [max]="todayDateTimeMax"
              (ngModelChange)="onToPickerChange()"
            />
          </div>
        </div>
      </div>
      }
      <!-- Row 2: Trip Fields — dd-mm-yyyy display with calendar icon -->
      @if (playbackMode === 'trip') {
      <div class="playback-row-2">
        <div class="playback-col-trip">
          <label class="filter-label">Date</label>
          <div class="relative flex items-center">
            <input
              type="text"
              readonly
              class="w-full pl-2 pr-7 py-1.5 text-xs bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
              [value]="playbackTrip.dateDisplay || ''"
              placeholder="DD-MM-YYYY"
              (click)="tripDatePicker.showPicker()"
            />
            <svg
              class="absolute right-2 w-3.5 h-3.5 text-gray-400 pointer-events-none"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <input
              #tripDatePicker
              type="date"
              class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              [(ngModel)]="playbackTrip.date"
              [max]="todayDateMax"
              (ngModelChange)="onTripDatePickerChange()"
            />
          </div>
        </div>
        <div class="playback-col-trip">
          <label class="filter-label">Select Trip</label>
          <nz-select
            class="slctBx"
            nzShowSearch
            nzAllowClear
            [nzPlaceHolder]="
              tripDataLoading ? 'Loading trips...' : 'Please select Trip'
            "
            [(ngModel)]="playbackTrip.tripId"
            (ngModelChange)="onTripChange($event)"
            style="width: 100%"
            [nzLoading]="tripDataLoading"
            [nzDisabled]="tripDataLoading"
          >
            @for (trip of availableTripsData; track trip) {
            <nz-option
              [nzValue]="trip.trp_rn_id"
              [nzLabel]="trip.rte_nm"
            ></nz-option>
            }
          </nz-select>
        </div>
      </div>
      }
      <!-- Row 3: Run playback button -->
      <div class="playback-row-3">
        <button
          class="btn btn-primary btn-sm btn-block"
          type="button"
          (click)="simulatePlayback()"
          [disabled]="playbackLoading || !playbackFilters.vehicleId"
        >
          {{ playbackLoading ? "Preparing..." : "Run playback" }}
        </button>
      </div>
      <!-- Row 4: Target Tripwise Details Cards -->
      @if (playbackLine) {
      <div class="playback-row-4">
        <div class="tripwise-cards-container">
          <h7 class="tripwise-header">Target Tripwise Details</h7>
          <div class="tripwise-cards-row">
            <div class="tripwise-card">
              <div class="tripwise-card-value">
                {{ actualTimeDisplay || "--" }}
              </div>
              <div class="tripwise-card-label">(Actual Time)</div>
            </div>
            <div class="tripwise-card">
              <div class="tripwise-card-value">
                {{ totalTravelTime || "--" }}
              </div>
              <div class="tripwise-card-label">(Travel Time)</div>
            </div>
            <div class="tripwise-card">
              <div class="tripwise-card-value">
                {{ trackVehicleSpeed || "0" }}
              </div>
              <div class="tripwise-card-label">(Speed)</div>
            </div>
            <div class="tripwise-card">
              <div class="tripwise-card-value">{{ travelDist || "--" }}</div>
              <div class="tripwise-card-label">(Travel Distance)</div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </aside>

  <!-- Drawer Toggle Button (when collapsed - right next to panel) -->
  @if (!leftDrawerOpen) {
  <button
    class="drawer-toggle"
    (click)="toggleLeftDrawer()"
    title="Open Live Track Panel"
  >
    <span class="arrow-icon">▶</span>
  </button>
  }

  <!-- Map Controls (Overlay) -->
  <div
    class="map-controls"
    [class.with-slider]="showVehicleSlider && activeHeaderTab === 'livetrack'"
  >
    <button
      type="button"
      class="map-control-btn"
      title="Filters"
      (click)="toggleFiltersPanel()"
      [class.active]="showFiltersPanel"
    >
      <span>🎛️</span>
    </button>
    <button
      type="button"
      class="map-control-btn"
      title="Layers"
      (click)="toggleToolPanel('layers')"
      [class.active]="activeTool === 'layers'"
    >
      <span>🗺️</span>
    </button>
    <!-- <button type="button" class="map-control-btn" title="Share">
              <span>🔗</span>
            </button> -->
    <!-- <button type="button" class="map-control-btn" title="Person" *ngIf="activeHeaderTab === 'playback'">
            <span>👤</span>
          </button> -->
    <button
      type="button"
      class="map-control-btn"
      title="Location"
      (click)="toggleLocationFilter()"
      [class.active]="showLocationFilter"
    >
      <span>📍</span>
    </button>
    <button
      type="button"
      class="map-control-btn"
      title="Vehicle Status Legend"
      (click)="toggleVehicleStatusLegend()"
      [class.active]="showVehicleStatusLegend"
    >
      <span>📋</span>
    </button>
    <!-- <button type="button" class="map-control-btn" title="Vehicle Details" *ngIf="activeHeaderTab === 'playback' && selectedVehicle" (click)="showVehicleSlider = true; showPlaybackBottomPanel = false" [class.active]="showVehicleSlider">
          <span>🚗</span>
        </button> -->
    <button
      type="button"
      class="map-control-btn"
      title="Fullscreen"
      (click)="toggleFullscreen()"
    >
      <span>⛶</span>
    </button>
  </div>

  <!-- Vehicle Widget (Right side, after map controls - only in livetrack mode) -->
  @if (showVehicleSlider && selectedVehicleRaw && activeHeaderTab ===
  'livetrack') {
  <div class="vehicle-slider-container">
    <button
      type="button"
      class="slider-close-btn"
      (click)="closeVehicleSlider()"
      aria-label="Close slider"
    >
      <span>×</span>
    </button>
    <app-veh-widget
      [vehicle]="selectedVehicleRawSnapshot || selectedVehicleRaw"
      [playbackDate]="getPlaybackDateForWidget()"
      [playbackVehicleId]="
        playbackFilters.vehicleId ||
        (selectedVehicleRawSnapshot || selectedVehicleRaw)?.asrt_id
      "
    >
    </app-veh-widget>
  </div>
  }

  <!-- Playback Overlay Cards (Vehicle Details, Driver Details, Parking Points, Target Tripwise Details) - Bottom Strip -->
  <!-- Cards are always visible when showCard is true, even when collapsed (headers shown) -->
  <!-- <div class="playback-overlay-cards" *ngIf="activeHeaderTab === 'playback' && selectedVehicle"> -->

  <!-- Vehicle Details Card - Always show header when card is enabled -->
  <!-- <div class="overlay-card vehicle-overlay-card" *ngIf="showVehicleCard"
      [class.collapsed]="isCardCollapsed('vehicle')">
      <div class="overlay-card-header" (click)="toggleCard('vehicle')">
        <h6>Vehicle Details</h6>
        <button type="button" class="overlay-close-btn" (click)="toggleCard('vehicle'); $event.stopPropagation()"
          title="Toggle">
          <span>{{ isCardCollapsed('vehicle') ? '↑' : '↓' }}</span>
        </button>
      </div>
      <div class="overlay-card-body" *ngIf="!isCardCollapsed('vehicle')">
        <div class="overlay-detail-row">
          <span class="overlay-label">Vehicle:</span>
          <span class="overlay-value">{{ selectedVehicle?.id || selectedVehicleRaw?.asrt_nm || '--' }}</span>
        </div>
        <div class="overlay-detail-row">
          <span class="overlay-label">Category:</span>
          <span class="overlay-value">{{ selectedVehicle?.asrt_ctgry_nm || selectedVehicleRaw?.asrt_ctgry_nm || '--'
          }}</span>
        </div>
        <div class="overlay-detail-row">
          <span class="overlay-label">IMEI:</span>
          <span class="overlay-value">{{ selectedVehicle?.dev_imei_nu || selectedVehicleRaw?.dev_imei_nu || '--'
          }}</span>
        </div>
        <div class="overlay-detail-row" *ngIf="selectedVehicleRaw">
          <span class="overlay-label">Odometer:</span>
          <span class="overlay-value">{{ selectedVehicleRaw?.odmtr_ct || '--' }}</span>
        </div>
        <div class="overlay-detail-row" *ngIf="selectedVehicleRaw">
          <span class="overlay-label">Speed:</span>
          <span class="overlay-value">{{ trackVehicleSpeed || selectedVehicleRaw?.spd_ct || 0 }} km/h</span>
        </div>

      </div>
    </div> -->

  <!-- Driver Details Card - Always show header when card is enabled -->
  <!-- <div class="overlay-card driver-overlay-card" *ngIf="showDriverCard" [class.collapsed]="isCardCollapsed('driver')">
    <div class="overlay-card-header" (click)="toggleCard('driver')">
      <h6>Driver Details</h6>
      <button type="button" class="overlay-close-btn" (click)="toggleCard('driver'); $event.stopPropagation()"
        title="Toggle">
        <span>{{ isCardCollapsed('driver') ? '↑' : '↓' }}</span>
      </button>
    </div>
    <div class="overlay-card-body" *ngIf="!isCardCollapsed('driver')">
      <div class="overlay-detail-row">
        <span class="overlay-label">Name:</span>
        <span class="overlay-value">{{ selectedTripData?.drvr_nm || selectedVehicle?.driver?.name || selectedVehicleRaw?.drvr_nm || '--' }}</span>
      </div>
      <div class="overlay-detail-row">
        <span class="overlay-label">Mobile:</span>
        <span class="overlay-value">{{ selectedTripData?.drvr_phne_nu || selectedVehicle?.driver?.contact || selectedVehicleRaw?.drvr_mbl_nu || '--'
        }}</span>
      </div>
      <div class="overlay-detail-row">
        <span class="overlay-label">License:</span>
        <span class="overlay-value">{{ selectedVehicle?.driver?.license || selectedVehicleRaw?.drvr_lcnc_nu || '--'
        }}</span>
      </div>
      <div class="overlay-detail-row" *ngIf="selectedVehicleRaw?.drvr_doj">
        <span class="overlay-label">DOJ:</span>
        <span class="overlay-value">{{ selectedVehicleRaw.drvr_doj || '--' }}</span>
      </div>
    </div>
  </div> -->
  <!-- Target Tripwise Details Card - Always show header when card is enabled -->
  <!-- <div class="overlay-card tripwise-overlay-card"
  *ngIf="(isPlaybackPlaying || playbackPoints.length > 0) && showTripwiseCard"
  [class.collapsed]="isCardCollapsed('tripwise')">
  <div class="overlay-card-header" (click)="toggleCard('tripwise')">
    <h6>Target Tripwise Details</h6>
    <button type="button" class="overlay-close-btn" (click)="toggleCard('tripwise'); $event.stopPropagation()"
      title="Toggle">
      <span>{{ isCardCollapsed('tripwise') ? '↑' : '↓' }}</span>
    </button>
  </div>
  <div class="overlay-card-body tripwise-body" *ngIf="!isCardCollapsed('tripwise')">
    <table class="tripwise-overlay-table">
      <tr>
        <td>
          <p class="tripwise-value">{{ trackVehicleTimestamp || '--' }}</p>
          <h2 class="tripwise-label">(Actual Time)</h2>
        </td>
        <td>
          <p class="tripwise-value">{{ totalTravelTime || '--' }}</p>
          <h2 class="tripwise-label">(Travel Time)</h2>
        </td>
        <td>
          <p class="tripwise-value">{{ travelDist || '--' }}</p>
          <h2 class="tripwise-label">(Travel Distance)</h2>
        </td>
      </tr>
      <tr>
        <td>
          <p class="tripwise-value">{{ trackVehicleSpeed || '0' }}</p>
          <h2 class="tripwise-label">(Speed)</h2>
        </td>
        <td>
          <p class="tripwise-value">{{ selectedTripData?.drvr_nm || selectedVehicle?.driver?.name || selectedVehicleRaw?.drvr_nm || '--' }}</p>
          <h2 class="tripwise-label">(Driver Name)</h2>
        </td>
        <td>
          <p class="tripwise-value">{{ selectedTripData?.drvr_phne_nu || selectedVehicle?.driver?.contact || selectedVehicleRaw?.drvr_mbl_nu || '--' }}</p>
          <h2 class="tripwise-label">(Driver Mobile)</h2>
        </td>
      </tr>
    </table>
  </div>
</div> -->

  <!-- Parking Points Card - Always show header when card is enabled -->
  <!-- <div class="overlay-card parking-overlay-card" *ngIf="playbackParkingPoints.length > 0 && showParkingCard"
[class.collapsed]="isCardCollapsed('parking')">
<div class="overlay-card-header" (click)="toggleCard('parking')">
  <h6>Parking Points ({{ playbackParkingPoints.length }})</h6>
  <button type="button" class="overlay-close-btn" (click)="toggleCard('parking')"
    title="Toggle">
    <span>{{ isCardCollapsed('parking') ? '↑' : '↓' }}</span>
  </button>
</div>
<div class="overlay-card-body parking-list" *ngIf="!isCardCollapsed('parking')">
  <div class="parking-total-info"
    style="padding: 8px; background: #f3f4f6; border-radius: 4px; margin-bottom: 8px; font-size: 12px; font-weight: 600; color: #374151; text-align: center;">
    Total Parking Points: {{ playbackParkingPoints.length }}
  </div>
  <div class="parking-item" *ngFor="let point of playbackParkingPoints.slice(0, 3); let i = index"
    (click)="focusOnParkingPoint(point)">
    <span class="parking-number">P{{ point.sno || (i + 1) }}</span>
    <span class="parking-duration">{{ point.stoppageTime || '--' }} min</span>
  </div>
  <div class="parking-more" *ngIf="playbackParkingPoints.length >= 1" (click)="showParkingPointsTable = true">
  show table view </div>
  <div class="parking-more" *ngIf="playbackParkingPoints.length > 3" (click)="showParkingPointsTable = true">
    +{{ playbackParkingPoints.length - 3 }} more...
  </div>

</div>
</div> -->

  <!-- Playback Data Card - Shows all playback points in table -->
  <!-- <div class="overlay-card playback-data-overlay-card" *ngIf="playbackDataPoints.length > 0 && showPlaybackDataCard"
[class.collapsed]="isCardCollapsed('playbackData')">
<div class="overlay-card-header" (click)="toggleCard('playbackData')">
  <h6>Playback Data ({{ playbackDataPoints.length }})</h6>
  <button type="button" class="overlay-close-btn" (click)="toggleCard('playbackData'); $event.stopPropagation()"
    title="Toggle">
    <span>{{ isCardCollapsed('playbackData') ? '↑' : '↓' }}</span>
  </button>
</div>
<div class="overlay-card-body playback-data-table" *ngIf="!isCardCollapsed('playbackData')">
  <div class="table-container" style="max-height: 300px; overflow-y: auto;">
    <table class="playback-data-table-content">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Vehicle</th>
          <th>IMEI</th>
          <th>Speed</th>
          <th>Latitude</th>
          <th>Longitude</th>
          <th>Time</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let point of playbackDataPoints; let i = index"
          (click)="highlightPlaybackPoint(point)"
          class="playback-data-row"
          [class.highlighted]="highlightedPointMarker && point.lat === highlightedPointMarker.getLatLng().lat && point.lng === highlightedPointMarker.getLatLng().lng">
          <td>{{ i + 1 }}</td>
          <td>{{ point.asrt_nm || '--' }}</td>
          <td>{{ point.dev_imei_nu || '--' }}</td>
          <td>{{ point.speed_ct || 0 }} km/h</td>
          <td>{{ point.lat?.toFixed(6) || '--' }}</td>
          <td>{{ point.lng?.toFixed(6) || '--' }}</td>
          <td>{{ point.Signal || '--' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div> -->
  <!-- </div> -->

  <!-- Parking Points Table Modal (shown when clicking "more") -->
  @if (showParkingPointsTable) {
  <div class="parking-table-modal" (click)="showParkingPointsTable = false">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h6>Parking Points</h6>
        <button
          type="button"
          class="btn-export-small"
          (click)="exportParkingPointsExcel()"
          [disabled]="playbackParkingPoints.length === 0"
        >
          📥 Export
        </button>
        <button
          type="button"
          class="modal-close-btn"
          (click)="showParkingPointsTable = false"
        >
          ×
        </button>
      </div>
      <div class="modal-body">
        <app-data-grid
          class="parking-grid"
          [dataSource]="playbackParkingPoints"
          [searchPanel]="false"
          [filterRow]="false"
          [filterPanel]="false"
          [groupPanel]="false"
          [columnChooser]="false"
          [allowExport]="playbackCompleted"
          [exportFileName]="'ParkingPoints'"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
          [wordWrapEnabled]="true"
        >
          <app-grid-column
            dataField="sno"
            caption="S.No"
            width="60"
            alignment="center"
          ></app-grid-column>
          <app-grid-column
            dataField="asrt_nm"
            caption="Vehicle"
            alignment="center"
            width="100"
          ></app-grid-column>
          <app-grid-column
            dataField="Signal"
            caption="From"
            width="120"
            alignment="center"
          ></app-grid-column>
          <app-grid-column
            dataField="lastTime"
            caption="To"
            width="120"
            alignment="center"
          ></app-grid-column>
          <app-grid-column
            dataField="stoppageTime"
            caption="Duration"
            alignment="center"
            width="80"
          ></app-grid-column>
          <app-grid-column
            dataField="lat"
            caption="Latitude"
            alignment="center"
            width="100"
          ></app-grid-column>
          <app-grid-column
            dataField="lng"
            caption="Longitude"
            alignment="center"
            width="100"
          ></app-grid-column>
        </app-data-grid>
      </div>
    </div>
  </div>
  }

  <!-- Playback Controls (Play/Pause buttons and Speed Slider) - Right Side Icons (Below Map Controls) -->
  @if (activeHeaderTab === 'playback' && playbackFilters.vehicleId) {
  <div class="playback-controls-right">
    <!-- Play/Pause Buttons -->
    @if (!pausePlayback && isPlaybackPlaying) {
    <button
      type="button"
      class="playback-control-btn pause-btn"
      (click)="pausePlaybackControl()"
      title="Pause"
    >
      <span style="font-size: 20px">⏸</span>
    </button>
    } @if (pausePlayback || !isPlaybackPlaying) {
    <button
      type="button"
      class="playback-control-btn play-btn"
      (click)="playPlayback()"
      title="Play"
    >
      <span style="font-size: 20px">▶</span>
    </button>
    }
    <!-- Speed Slider Button -->
    <button
      type="button"
      class="playback-control-btn speed-btn"
      [class.active]="showSpeedSlider"
      (click)="showSpeedSlider = !showSpeedSlider"
      title="Speed Control"
    >
      <span style="font-size: 10px">⏪⏩</span>
    </button>
    <!-- Speed Slider Panel (shown when speed button clicked) -->
    @if (showSpeedSlider) {
    <div class="speed-slider-panel">
      <div class="speed-display">
        {{
          playbackSpeedSliderValue <= 100
            ? 1
            : playbackSpeedSliderValue <= 150
            ? 1.5
            : playbackSpeedSliderValue <= 200
            ? 2.0
            : 3.0
        }}x
      </div>
      <div class="slider-controls">
        <button
          type="button"
          class="slider-btn"
          (click)="
            onPlaybackSpeedSliderChange(
              playbackSpeedSliderValue > 100
                ? playbackSpeedSliderValue - 50
                : 100
            )
          "
          title="Decrease Speed"
        >
          −
        </button>
        <input
          type="range"
          class="speed-slider"
          min="100"
          max="250"
          step="50"
          [(ngModel)]="playbackSpeedSliderValue"
          (ngModelChange)="onPlaybackSpeedSliderChange($event)"
        />
        <button
          type="button"
          class="slider-btn"
          (click)="
            onPlaybackSpeedSliderChange(
              playbackSpeedSliderValue < 250
                ? playbackSpeedSliderValue + 50
                : 250
            )
          "
          title="Increase Speed"
        >
          +
        </button>
      </div>
      <div class="speed-tags">
        <span
          class="speed-tag"
          [class.active]="playbackSpeedSliderValue === 100"
          (click)="onPlaybackSpeedSliderChange(100)"
          >1.0x</span
        >
        <span
          class="speed-tag"
          [class.active]="playbackSpeedSliderValue === 150"
          (click)="onPlaybackSpeedSliderChange(150)"
          >1.5x</span
        >
        <span
          class="speed-tag"
          [class.active]="playbackSpeedSliderValue === 200"
          (click)="onPlaybackSpeedSliderChange(200)"
          >2.0x</span
        >
        <span
          class="speed-tag"
          [class.active]="playbackSpeedSliderValue === 250"
          (click)="onPlaybackSpeedSliderChange(250)"
          >3.0x</span
        >
      </div>
    </div>
    }
  </div>
  }

  <!-- Vehicle Status Legend Panel (Right side) -->
  @if (showVehicleStatusLegend && activeHeaderTab === 'livetrack') {
  <div class="vehicle-status-legend">
    <header>
      <span>Vehicle Status</span>
      <button type="button" (click)="toggleVehicleStatusLegend()">×</button>
    </header>
    <div class="legend-content">
      <ul class="legend-list">
        <li>
          <span
            class="greenCls"
            style="
              height: 12px;
              width: 12px;
              display: inline-block;
              border-radius: 2px;
              background-color: #22c55e;
            "
          ></span>
          <span>Running</span>
        </li>
        <li>
          <span
            class="blueCls"
            style="
              height: 12px;
              width: 12px;
              display: inline-block;
              border-radius: 2px;
              background-color: #3b82f6;
            "
          ></span>
          <span>Stationed for &lt; 5Min</span>
        </li>
        <li>
          <span
            class="yellowCls"
            style="
              height: 12px;
              width: 12px;
              display: inline-block;
              border-radius: 2px;
              background-color: #facc15;
            "
          ></span>
          <span>Stationed for 5Min - 15Min</span>
        </li>
        <li>
          <span
            class="redCls"
            style="
              height: 12px;
              width: 12px;
              display: inline-block;
              border-radius: 2px;
              background-color: #ef4444;
            "
          ></span>
          <span>Stationed for &gt; 15Min</span>
        </li>
        <li>
          <span
            class="greyCls"
            style="
              height: 12px;
              width: 12px;
              display: inline-block;
              border-radius: 2px;
              background-color: #94a3b8;
            "
          ></span>
          <span>Offline Vehicles</span>
        </li>
      </ul>
    </div>
  </div>
  } @if (showVehicleStatusLegend && activeHeaderTab === 'playback') {
  <div class="vehicle-status-legend">
    <header>
      <span>Legends</span>
      <button type="button" (click)="toggleVehicleStatusLegend()">×</button>
    </header>
    <div class="legend-content">
      <ul class="legend-list">
        <li>
          <span
            ><img
              style="height: 20px; width: 20px"
              src="/assets/images/markers/playback/startPoint.png"
              alt=""
          /></span>
          Source
        </li>
        <li>
          <span
            ><img
              style="height: 20px; width: 20px"
              src="/assets/images/markers/playback/endPoint.png"
              alt=""
          /></span>
          Destination
        </li>
        <li>
          <span
            ><img
              style="height: 20px; width: 20px"
              src="/assets/images/markers/playback/parking.png"
              alt=""
          /></span>
          Parking
        </li>
        <li>
          <span
            ><img
              style="height: 20px; width: 20px"
              src="/assets/images/markers/playback/parkingRed.png"
              alt=""
          /></span>
          Parking more than 10 Min
        </li>
      </ul>
    </div>
  </div>
  }

  <!-- Zoom Controls (Overlay) -->
  <div
    class="zoom-controls"
    [class.with-slider]="showVehicleSlider && activeHeaderTab === 'livetrack'"
  >
    <button type="button" class="zoom-btn" (click)="zoomIn()">+</button>
    <button type="button" class="zoom-btn" (click)="zoomOut()">-</button>
  </div>

  <!-- Filters Panel (Icon-based, opens on right) -->
  @if (showFiltersPanel) {
  <div class="filters-panel-overlay">
    <header>
      <span>Filters</span>
      <button type="button" (click)="toggleFiltersPanel()">×</button>
    </header>
    <div class="filters-content">
      <label class="filter-row">
        <span>Show ULB/Mandal</span>
        <select
          class="form-select form-select-sm"
          [ngModel]="selectedTenant"
          (ngModelChange)="selectedTenant = $event; onTenantChange()"
        >
          @for (tnt of tenantOptions; track tnt) {
          <option [value]="tnt.tnt_id">
            {{ tnt.tnt_nm }}
          </option>
          }
        </select>
      </label>
      <label class="filter-row">
        <span>Select Vehicle Group</span>
        <select
          class="form-select form-select-sm"
          [ngModel]="selectedVehicleGroup"
          (ngModelChange)="
            selectedVehicleGroup = $event; onVehicleGroupChange()
          "
        >
          <option [ngValue]="0">All groups</option>
          @for (grp of vehicleGroupOptions; track grp) {
          <option [ngValue]="grp.asrt_grp_id">
            {{ grp.asrt_grp_nm }}
          </option>
          }
        </select>
      </label>
      <label class="filter-row">
        <span>Select Vehicle Category</span>
        <select
          class="form-select form-select-sm"
          [ngModel]="selectedVehicleCategory"
          (ngModelChange)="onVehicleCategoryChange($event)"
        >
          <option [ngValue]="0">All categories</option>
          @for (cat of vehicleCategoryOptions; track cat) {
          <option [ngValue]="cat.asrt_ctgry_id">
            {{ cat.asrt_ctgry_nm }}
          </option>
          }
        </select>
      </label>
    </div>
  </div>
  }

  <!-- Map Layers Panel (Icon-based) -->
  @if (activeTool === 'layers') {
  <div class="layers-panel" [class.with-filters]="showFiltersPanel">
    <header>
      <span>Map Layers</span>
      <button type="button" (click)="toggleToolPanel('layers')">×</button>
    </header>
    <div class="layers-content">
      <div
        class="layer-option"
        [class.active]="selectedLayer === 'street'"
        (click)="setMapLayer('street')"
      >
        <div class="layer-icon">🗺️</div>
        <div class="layer-info">
          <span class="layer-name">Google Streets</span>
          <span class="layer-desc">Standard street map</span>
        </div>
        @if (selectedLayer === 'street') {
        <div class="layer-check">✓</div>
        }
      </div>
      <div
        class="layer-option"
        [class.active]="selectedLayer === 'osm'"
        (click)="setMapLayer('osm')"
      >
        <div class="layer-icon">🌍</div>
        <div class="layer-info">
          <span class="layer-name">OpenStreetMap</span>
          <span class="layer-desc">Open source map</span>
        </div>
        @if (selectedLayer === 'osm') {
        <div class="layer-check">✓</div>
        }
      </div>
      <div
        class="layer-option"
        [class.active]="selectedLayer === 'sat'"
        (click)="setMapLayer('sat')"
      >
        <div class="layer-icon">🛰️</div>
        <div class="layer-info">
          <span class="layer-name">Satellite</span>
          <span class="layer-desc">Satellite imagery</span>
        </div>
        @if (selectedLayer === 'sat') {
        <div class="layer-check">✓</div>
        }
      </div>
      <div
        class="layer-option"
        [class.active]="selectedLayer === 'topo'"
        (click)="setMapLayer('topo')"
      >
        <div class="layer-icon">⛰️</div>
        <div class="layer-info">
          <span class="layer-name">OpenTopoMap</span>
          <span class="layer-desc">Topographic map</span>
        </div>
        @if (selectedLayer === 'topo') {
        <div class="layer-check">✓</div>
        }
      </div>
    </div>
  </div>
  }

  <!-- Location Filter Panel (Separate Drawer) -->
  @if (showLocationFilter) {
  <div class="location-filter-panel" [class.with-filters]="showFiltersPanel">
    <header>
      <span>Location Filter</span>
      <button type="button" (click)="closeLocationFilter()">×</button>
    </header>
    <div class="location-filter-content">
      <label class="filter-row">
        <span>Show Location Group</span>
        <select
          class="form-select form-select-sm"
          [ngModel]="selectedLocationGroup"
          (ngModelChange)="
            selectedLocationGroup = $event; onLocationGroupChange()
          "
        >
          <option [ngValue]="0">All locations</option>
          @for (loc of locationGroupOptions; track loc) {
          <option [ngValue]="loc.fnce_grp_id">
            {{ loc.fnce_grp_nm }}
          </option>
          }
        </select>
      </label>
      @if (selectedLocationGroup > 0 && locationList.length > 0) {
      <label class="filter-row">
        <span>Show Locations</span>
        <select
          class="form-select form-select-sm"
          [ngModel]="selectedLocation"
          (ngModelChange)="selectedLocation = $event; onLocationChange()"
        >
          <option value="select">All Locations</option>
          <option value="deselect">None</option>
          @for (loc of locationList; track loc) {
          <option [value]="loc.fnce_id">
            {{ loc.fnce_nm }}
          </option>
          }
        </select>
      </label>
      }
    </div>
  </div>
  }

  <!-- Playback Bottom Terminal (Adjustable slider at bottom) -->
  @if (activeHeaderTab === 'playback' && (isPlaybackPlaying ||
  playbackPoints.length > 0 || playbackDataPoints.length > 0 ||
  playbackParkingPoints.length > 0)) {
  <div
    class="playback-bottom-terminal"
    [class.sidebar-open]="leftDrawerOpen"
    [style.height.px]="showPlaybackBottomPanel ? playbackTerminalHeight : 48"
    [class.terminal-closed]="!showPlaybackBottomPanel"
  >
    <!-- Terminal Header (always visible) -->
    <div class="terminal-header">
      <div class="terminal-tabs">
        <button
          type="button"
          class="terminal-tab"
          [class.active]="playbackBottomPanelTab === 'info'"
          (click)="setPlaybackBottomTab('info')"
        >
          Info
        </button>
        <button
          type="button"
          class="terminal-tab"
          [class.active]="playbackBottomPanelTab === 'parking'"
          (click)="setPlaybackBottomTab('parking')"
        >
          Parking Points
        </button>
        <button
          type="button"
          class="terminal-tab"
          [class.active]="playbackBottomPanelTab === 'playback'"
          (click)="setPlaybackBottomTab('playback')"
        >
          Playback
        </button>
      </div>
      <div class="terminal-controls">
        <button
          type="button"
          class="terminal-toggle-btn"
          (click)="togglePlaybackBottomPanel()"
          [title]="showPlaybackBottomPanel ? 'Close Terminal' : 'Open Terminal'"
        >
          {{ showPlaybackBottomPanel ? "▼" : "▲" }}
        </button>
      </div>
    </div>
    <!-- Terminal Content -->
    @if (showPlaybackBottomPanel) {
    <div class="terminal-content">
      <!-- Info Tab -->
      @if (playbackBottomPanelTab === 'info') {
      <div class="terminal-tab-content">
        <div class="info-cards-container">
          <!-- Vehicle Details Card -->
          <section class="widget-card vehicle-card">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <h2>Vehicle Details</h2>
              <div class="veList">
                <div class="info-row">
                  <div class="info-label">
                    <h3>Vehicle Registration Number</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value fw-600">
                    <h4 class="value-emphasis">
                      {{
                        selectedVehicle?.id ||
                          selectedVehicleRaw?.asrt_nm ||
                          "NA"
                      }}
                    </h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Vehicle Category</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>
                      {{
                        selectedVehicle?.asrt_ctgry_nm ||
                          selectedVehicleRaw?.asrt_ctgry_nm ||
                          "NA"
                      }}
                    </h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>IMEI Number</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>
                      {{
                        selectedVehicle?.dev_imei_nu ||
                          selectedVehicleRaw?.dev_imei_nu ||
                          "NA"
                      }}
                    </h4>
                  </div>
                </div>
                @if (selectedVehicleRaw) {
                <div class="info-row">
                  <div class="info-label">
                    <h3>Vehicle Odometer Reading</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ selectedVehicleRaw?.odmtr_ct || 0 }} km</h4>
                  </div>
                </div>
                } @if (selectedVehicleRaw) {
                <div class="info-row">
                  <div class="info-label">
                    <h3>Speed</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>
                      {{ trackVehicleSpeed || selectedVehicleRaw?.spd_ct || 0 }}
                      km/Hr
                    </h4>
                  </div>
                </div>
                }
              </div>
            </div>
          </section>
          <!-- Driver Details Card -->
          <section class="widget-card driver-card">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <h2>Driver Details</h2>
              <div class="veList">
                <div class="info-row">
                  <div class="info-label">
                    <h3>Driver Name</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>
                      {{
                        selectedTripData?.drvr_nm ||
                          selectedVehicleRaw?.drvr_nm ||
                          "Driver not assigned"
                      }}
                    </h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Driver Phone Number</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>
                      {{
                        selectedTripData?.drvr_phne_nu ||
                          selectedVehicleRaw?.drvr_mbl_nu ||
                          "Driver not assigned"
                      }}
                    </h4>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-label">
                    <h3>Driver License Number</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ selectedVehicleRaw?.drvr_lcnc_nu || "NA" }}</h4>
                  </div>
                </div>
                @if (selectedVehicleRaw?.drvr_doj) {
                <div class="info-row">
                  <div class="info-label">
                    <h3>Driver DOJ</h3>
                  </div>
                  <div class="info-separator">:</div>
                  <div class="info-value">
                    <h4>{{ selectedVehicleRaw.drvr_doj || "NA" }}</h4>
                  </div>
                </div>
                }
              </div>
            </div>
          </section>
        </div>
      </div>
      }
      <!-- Parking Points Tab -->
      @if (playbackBottomPanelTab === 'parking') {
      <div class="terminal-tab-content">
        <div class="parking-table-container">
          <app-data-grid
            [exportFileName]="'ParkingPoints'"
            class="parking-grid"
            [dataSource]="playbackParkingPoints"
            [searchPanel]="false"
            [filterRow]="false"
            [filterPanel]="false"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="
              playbackCompleted && playbackParkingPoints.length > 0
            "
            [pageSize]="10"
            [allowedPageSizes]="[10, 25, 50, 100]"
            [showPageSizeSelector]="true"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="true"
            (rowClick)="onParkingPointRowClick($event)"
          >
            <!-- -->
            <app-grid-column
              dataField="sno"
              caption="S.No"
              width="100"
              alignment="center"
            ></app-grid-column>
            <app-grid-column
              dataField="sno"
              caption="Parking Point"
              alignment="center"
              width="auto"
            ></app-grid-column>
            <app-grid-column
              dataField="asrt_nm"
              caption="Vehicle"
              alignment="center"
              width="auto"
            ></app-grid-column>
            <app-grid-column
              dataField="Signal"
              caption="From"
              width="auto"
              alignment="center"
            ></app-grid-column>
            <app-grid-column
              dataField="lastTime"
              caption="To"
              width="auto"
              alignment="center"
            ></app-grid-column>
            <app-grid-column
              dataField="stoppageTime"
              caption="Duration"
              alignment="center"
              width="auto"
            ></app-grid-column>
            <app-grid-column
              dataField="lat"
              caption="Latitude"
              alignment="center"
              width="auto"
            ></app-grid-column>
            <app-grid-column
              dataField="lng"
              caption="Longitude"
              alignment="center"
              width="auto"
            ></app-grid-column>
          </app-data-grid>
        </div>
      </div>
      }
      <!-- Playback Tab -->
      @if (playbackBottomPanelTab === 'playback') {
      <div class="terminal-tab-content">
        @if (playbackDataPoints.length > 0) {
        <div class="playback-table-container">
          <app-data-grid
            [exportFileName]="'PlaybackData'"
            class="playback-grid"
            [dataSource]="playbackDataPoints"
            [searchPanel]="false"
            [filterRow]="false"
            [filterPanel]="false"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="playbackCompleted && playbackDataPoints.length > 0"
            [pageSize]="10"
            [allowedPageSizes]="[10, 25, 50, 100]"
            [showPageSizeSelector]="true"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="true"
            (rowClick)="onPlaybackPointRowClick($event)"
          >
            <!-- -->
            <app-grid-column
              dataField="sno"
              caption="S.No"
              width="100"
              alignment="center"
            ></app-grid-column>
            <app-grid-column
              dataField="asrt_nm"
              caption="Vehicle"
              alignment="center"
              width="auto"
              [allowSorting]="true"
            ></app-grid-column>
            <app-grid-column
              dataField="dev_imei_nu"
              caption="IMEI"
              alignment="center"
              width="auto"
              [allowSorting]="true"
            ></app-grid-column>
            <app-grid-column
              dataField="speed_ct"
              caption="Speed"
              alignment="center"
              width="auto"
              [format]="{ type: 'fixedPoint', precision: 0 }"
              [allowSorting]="true"
            ></app-grid-column>
            <app-grid-column
              dataField="milage_ct"
              caption="odometer"
              alignment="center"
              width="auto"
              [allowSorting]="true"
            ></app-grid-column>
            <app-grid-column
              dataField="ignition_in"
              caption="Ignition"
              alignment="center"
              width="auto"
              [allowSorting]="true"
            ></app-grid-column>
            <app-grid-column
              dataField="sgnl_strngth_ct"
              caption="Signal"
              alignment="center"
              width="auto"
              [allowSorting]="true"
            ></app-grid-column>
            <app-grid-column
              dataField="lat"
              caption="Latitude"
              alignment="center"
              width="auto"
              [format]="{ type: 'fixedPoint', precision: 6 }"
              [allowSorting]="true"
            ></app-grid-column>
            <app-grid-column
              dataField="lng"
              caption="Longitude"
              alignment="center"
              width="auto"
              [format]="{ type: 'fixedPoint', precision: 6 }"
              [allowSorting]="true"
            ></app-grid-column>
            <app-grid-column
              dataField="Signal"
              caption="Time"
              alignment="center"
              width="auto"
              [allowSorting]="true"
            ></app-grid-column>
          </app-data-grid>
        </div>
        } @if (playbackDataPoints.length === 0) {
        <div class="empty-playback-message">
          <p>No playback data available. Run playback to see data points.</p>
        </div>
        }
      </div>
      }
    </div>
    }
    <!-- Resize Handle -->
    @if (showPlaybackBottomPanel) {
    <div
      class="terminal-resize-handle"
      (mousedown)="startResizeTerminal($event)"
    ></div>
    }
  </div>
  }
</div>
